/**
 * Datenschutz (privacy policy) page generator
 * Tracking-aware: adapts cookie/tracking sections based on settings.trackingPreset
 */
import { esc } from '@/utils/escape';

export function generateDatenschutzHTML(settings: any): string {
  const legal = settings.companyLegal || {};
  const tracking = settings.trackingPreset || 'none';

  // Build tracking-specific sections
  let cookieSection = '';
  let trackingSection = '';

  if (tracking === 'ga4') {
    cookieSection =
      '      <h2>Cookies</h2>\n' +
      '      <p>Diese Website verwendet technisch notwendige Cookies sowie Analyse-Cookies von Google Analytics 4. ' +
      'Analyse-Cookies werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt (Opt-in).</p>\n' +
      '      <p>Technisch notwendige Cookies können nicht abgelehnt werden, da sie für den Betrieb der Website erforderlich sind. ' +
      'Sie können Ihre Cookie-Einstellungen jederzeit über den Cookie-Banner anpassen.</p>\n';

    trackingSection =
      '      <h2>Google Analytics 4</h2>\n' +
      '      <p>Diese Website benutzt Google Analytics 4 (GA4), einen Webanalysedienst der Google Ireland Limited (' +
      '«Google»), Gordon House, Barrow Street, Dublin 4, Irland.</p>\n' +
      '      <p>Google Analytics verwendet sogenannte «Cookies», Textdateien, die auf Ihrem Computer gespeichert werden und die eine ' +
      'Analyse der Benutzung der Website durch Sie ermöglichen. Die durch das Cookie erzeugten Informationen über Ihre Benutzung ' +
      'dieser Website werden in der Regel an einen Server von Google übertragen.</p>\n' +
      '      <p>Die IP-Anonymisierung ist auf dieser Website aktiviert. Ihre IP-Adresse wird von Google innerhalb von Mitgliedstaaten ' +
      'der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt.</p>\n' +
      '      <p>Die Datenerhebung erfolgt ausschliesslich mit Ihrer Einwilligung (Opt-in über den Cookie-Banner). ' +
      'Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.</p>\n';
  } else if (tracking === 'matomo') {
    cookieSection =
      '      <h2>Cookies</h2>\n' +
      '      <p>Diese Website verwendet technisch notwendige Cookies sowie Analyse-Cookies von Matomo. ' +
      'Analyse-Cookies werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt (Opt-in).</p>\n' +
      '      <p>Technisch notwendige Cookies können nicht abgelehnt werden, da sie für den Betrieb der Website erforderlich sind. ' +
      'Sie können Ihre Cookie-Einstellungen jederzeit über den Cookie-Banner anpassen.</p>\n';

    trackingSection =
      '      <h2>Webanalyse mit Matomo</h2>\n' +
      '      <p>Diese Website benutzt Matomo (ehemals Piwik), eine Open-Source-Software zur statistischen Auswertung ' +
      'der Besucherzugriffe. Matomo wird auf unseren eigenen Servern betrieben, sodass Ihre Daten unser Unternehmen nicht verlassen.</p>\n' +
      '      <p>Die Verarbeitung erfolgt ausschliesslich auf unserer eigenen Infrastruktur. Es werden keine Daten an Dritte weitergegeben.</p>\n' +
      '      <p>Die Datenerhebung erfolgt ausschliesslich mit Ihrer Einwilligung (Opt-in über den Cookie-Banner). ' +
      'Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.</p>\n';
  } else {
    // tracking === 'none'
    cookieSection =
      '      <h2>Cookies</h2>\n' +
      '      <p>Diese Website verwendet keine Tracking-Cookies. Technisch notwendige Cookies können verwendet werden, ' +
      'um die Funktionalität der Website zu gewährleisten.</p>\n';
    trackingSection = '';
  }

  return `<!DOCTYPE html>
<html lang="de"${settings.darkMode ? ' class="dark"' : ''}>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Datenschutz \u2013 ${esc(settings.siteName)}</title>
  <link rel="stylesheet" href="css/tokens.css">
  <link rel="stylesheet" href="css/components.css">
</head>
<body>
  <main class="legal-page">
    <div class="container">
      <h1>Datenschutzerkl\u00e4rung</h1>

      <h2>Verantwortliche Stelle</h2>
      <p>
        ${esc(legal.name)}<br>
        ${esc(legal.address)}<br>
        E-Mail: ${esc(legal.email)}
      </p>

      <h2>Erhebung und Verarbeitung von Daten</h2>
      <p>Beim Besuch dieser Website werden automatisch Informationen allgemeiner Natur erfasst. Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem und \u00e4hnliche Informationen.</p>

${cookieSection}
${trackingSection}
      <h2>Ihre Rechte</h2>
      <p>Sie haben das Recht auf Auskunft, Berichtigung, L\u00f6schung und Einschr\u00e4nkung der Verarbeitung Ihrer personenbezogenen Daten. Kontaktieren Sie uns hierf\u00fcr unter der oben genannten E-Mail-Adresse.</p>

      <p><a href="index.html">\u2190 Zur\u00fcck zur Startseite</a></p>
    </div>
  </main>
  <script src="js/main.js"><${'/'}script>
</body>
</html>`;
}
